'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.setImages = exports.updateImages = undefined;

var _functional = require('../utils/functional');

var _images = require('../utils/images');

var images = [];
var isLoading = false;

var updateImages = exports.updateImages = function updateImages() {
  images = (0, _functional.getElements)('.' + _images.CssClasses.LOADER);
};

var setImages = exports.setImages = function setImages() {
  isLoading = true;

  images.forEach(function (image) {
    // Check if image is inside viewport
    if (!image.lazyloaded && image.getBoundingClientRect().top < (0, _functional.getViewportSize)().vh) {
      (0, _images.loadImage)(image, { loadingClass: _images.CssClasses.LOADER });
    }
  });

  // Once the images have been loaded remove them from the list
  images = images.filter(function (image) {
    return !image.lazyloaded;
  });

  isLoading = false;
};

var init = exports.init = function init() {
  updateImages();
  setImages();

  document.addEventListener('scroll', function () {
    // Avoids setImages from running multiple times on scroll
    if (isLoading) return false;
    setImages();
  });
};